import React, { useContext, useState, useEffect } from 'react'
import GoogleMap from 'google-map-react'
import {
  Anchor, Box, Heading, Main, Paragraph,
  Stack, Text, Layer, Accordion, AccordionPanel,
  CardBody, CardHeader, Button, CardFooter, CheckBox, Tip, TextInput
} from 'grommet';
import { MotionBox } from './Motion';
import withOpsApi from './withOpsApi'
import {
  CircleInformation, Group, Link, FormView, Hide, Close, FormNextLink
} from 'grommet-icons'
import { RoundIconButton } from './Common'
import { MotionLayer } from './Motion'
import { AnimatePresence } from 'framer-motion'
import {
  MeshPin, NetworkCharity,
  PearWhiteLogo, NetworkOther
} from '../MeshIcon'
import {
  calculateImpactMetrics,
  getTotalByKeyFromResults,
  regionsCities,
  surplusMarketplaces
} from '../libs/common'
import { opsAPI } from '../api/retail'
import { AppContext } from '../libs/context'
import { DonationMetricsSmall, MetricsBox } from './Donations'
import firebase from '../libs/firebase'
import {
  LogoWithNoTagLine, NetworkPinBusiness,
  NetworkPinOther, NetworkPinRecipient, NetworkPinUpcycler, PearGreenGradLogo
} from '../Image';
const K_SIZE = 48
const catColors = ['#F4628F', '#50B6FF', '#f68b78'];
const defaultMapData = [
  {
    name: 'Food Businesses',
    show: 1,

    categories: [
      {
        name: 'Produce Farm',
        sf_attributes: ['Grower'],
        show: 1
      },
      {
        name: 'Food Service',
        sf_attributes: ['Restaurant/Hotel', 'Caterer', 'Food Service'],
        show: 1
      },
      {
        name: 'Manufacturer',
        sf_attributes: ['Manufacturer', 'Processor'],
        show: 1
      },
      {
        name: 'Retail/Grocer',
        sf_attributes: ['Retail/Grocer'],
        show: 1
      },
      {
        name: 'Wholesaler',
        sf_attributes: ['Distributor', 'Liquidator'],
        show: 1
      }
    ]
  },
  {
    name: 'Donation Recipients',
    show: 1,
    categories: [
      {
        name: 'Charity',
        sf_attributes: ['Charity', 'Nonprofit'],
        show: 1
      },
      {
        name: 'Farmer',
        sf_attributes: ['Farmer (Livestock)'],
        show: 1
      }
    ]
  },
  {
    name: 'Others',
    show: 1,
    categories: [
      {
        name: "Upcycler",
        sf_attributes: ['Up-Cycler'],
        show: 1
      },
      {
        name: 'Composter',
        sf_attributes: ['Composter'],
        show: 1
      },
      {
        name: 'Organic Waste Hauler',
        sf_attributes: ['Waste'],
        show: 1
      },
      {
        name: 'Industrial Recovery',
        sf_attributes: ['Industrial Recovery'],
        show: 1
      }
    ]
  }
]
const defaultMapData1 = [
  {
    name: 'Food Businesses',
    show: 1,

    categories: [
      {
        name: 'Producer/wild harvester',
        sf_attributes: ['Grower'],
        description: 'Produce growers, ranchers, egg, dairy and poultry producers, and fishers.',
        show: 1
      },
      {
        name: 'Manufacturer',
        sf_attributes: ['Manufacturer', 'Processor'],
        description: 'Makes food and sells it through a wholesale outlet.',
        show: 1
      },
      {
        name: 'Wholesaler',
        sf_attributes: ['Wholesaler', 'Distributor', 'Liquidator'],
        description: 'Procures food from growers and/or manufacturers \
        and sells it to retailers/ grocers and food service.',
        show: 1
      },
      {
        name: 'Retail/Grocer',
        sf_attributes: ['Retail/Grocer'],
        description: 'Sells food to consumers (e.g. supermarkets)',
        show: 1
      },
      {
        name: 'Food service',
        sf_attributes: ['Restaurant/Hotel', 'Caterer', 'Food Service'],
        description: 'Serves food to consumers (e.g. restaurants, cafes, bars,\
           cafeterias, caterers and institutional food providers).',
        show: 1
      }
    ]
  },
  {
    name: 'Food Recovery Outlets',
    show: 1,
    categories: [
      {
        name: 'Charity/non-profit',
        sf_attributes: ['Charity', 'Nonprofit'],
        description: 'Uses food donations to provide low-cost or free meals\
         and/ or groceries to people facing food insecurity.',
        show: 1
      },
      {
        name: 'Hobby farmer',
        sf_attributes: ['Farmer (Livestock)'],
        description: 'Uses food scraps to feed their privately owned,\
         non- commercial animals (not shown on the map for privacy reasons).',
        show: 1
      }
    ]
  },
  {
    name: 'Food Recyclers',
    show: 1,
    categories: [
      {
        name: "Upcycler",
        sf_attributes: ['Up-Cycler'],
        description: 'Recycles surplus edible food and/or edible by-products\
         from wholesalers and manufacturers to create a new food product (e.g.soup).',
        show: 1
      },
      {
        name: 'Industrial reworker',
        sf_attributes: ['Industrial Recovery'],
        description: 'Reprocesses discarded inedible food scraps and/or \
        inedible by- products into a non - food product (e.g.renewable energy).',
        show: 1
      },
      {
        name: 'Composter',
        sf_attributes: ['Composter'],
        description: 'Turns organic materials into soil amendments (e.g. compost).',
        show: 1
      },
      {
        name: 'Organic waste hauler',
        sf_attributes: ['Waste'],
        description: 'Hauls organic materials for composting or other uses.',
        show: 1
      }
    ]
  }
]
const icons = [NetworkPinBusiness, NetworkPinRecipient, NetworkPinUpcycler]
const markerStyle = {
  // initially any map object has left top corner at lat lng coordinates
  // it's on you to set object origin to 0,0 coordinates
  position: 'absolute',
  width: K_SIZE,
  height: K_SIZE,
  left: -K_SIZE / 2,
  top: -K_SIZE / 2,
  cursor: 'pointer'
}
const AttributesAsTags = ({ attributes = {}, hide = [] }) => {
  const allowedAttributes = Object.keys(attributes).map((key) => {
    return hide.includes(key) ? null : key
  })
  return (
    <Box flex={false} direction={'row'} wrap={true}>
      {allowedAttributes.map(
        (attribute) =>
          attribute && (
            <Box
              align={'center'}
              flex={false}
              pad={{ horizontal: 'xsmall', vertical: 'xxsmall' }}
              background={'light-4'}
              key={attribute}
              margin={{ right: 'xsmall', bottom: 'xsmall' }}
              round={'xsmall'}
            >
              <Text color={'dark-6'} size={'xsmall'} weight={'bold'}>
                {attribute}
              </Text>
            </Box>
          )
      )}
    </Box>
  )
}
const AccountCard = ({ name, address, sf_type, sf_attributes = [], data = {}, catIndex, show,
  closeAction, verified, ...rest }) => {
  const { website } = data;
  const Icon = icons[catIndex];
  return show && (
    <AnimatePresence inital={true}>
      (
      <MotionBox
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ type: 'spring', duration: 0.7 }}
        background='#FFF'
        {...rest}
      // width={width}
      >
        <CardHeader
          pad={{ left: 'medium', right: 'xxsmall', vertical: 'xxsmall' }}
          border={{ side: 'bottom' }}
          background={{ color: catColors[catIndex] }}
        >
          <Box justify='center' align='center'
            direction='row' >
            <Icon color='white' width={'30px'} height={'30px'} size='small' />
          </Box>
          <Text color={'white'} size='medium'>{name}</Text>
          <Button size='small' margin={{ right: 'small' }}
            icon={<Close size='small' color='white' />} onClick={() => closeAction()} />
        </CardHeader>
        <CardBody>
          <Box pad={{ horizontal: 'medium', vertical: 'small' }} gap={'small'} fill width={'150px'}>
            <Box direction={'row'} align={'center'} justify={'start'} gap={'small'}>
              <Paragraph fill>{address}</Paragraph>
              {website && (
                <RoundIconButton
                  background={'light-1'}
                  Icon={Link}
                  round={'small'}
                  href={website.startsWith('http') ? website : 'https://' + website}
                  onClick={() => { }}
                />
              )}
            </Box>
            <AttributesAsTags attributes={sf_attributes} hide={['Marketplace', 'Wholesale',
              'Retail Program', 'Non FoodMesh Network']} />
            {verified == 1 && <Box direction='row'
              align='center'>
              {/* <Box round pad={'xsmall'} margin={'xsmall'}> */}
              <PearGreenGradLogo width={'24px'} size='medium' />&nbsp;
              {/* </Box> */}
              <Text size='small'>FoodMesh Verified</Text>
            </Box>}
          </Box>
        </CardBody>
      </MotionBox>
      )
    </AnimatePresence>
  )
}


const MapPin = ({ catIndex, $hover, record }) => {
  const Icon = icons[catIndex];
  let borderStyle = {
    size: $hover ? 'medium' : 'small',
    style: 'dashed', color: '#fff'
  };
  if (record.verified == 1) {
    borderStyle['style'] = 'solid';
    borderStyle['color'] = '#01E4BF';
  }
  return (
    <div style={markerStyle}>
      <Box
        round
        justify='center'
        align='center'
        //height={$hover?'70px':'50px'}
        // width={$hover?'90px':'50px'}
        //background={{ color: $hover?'white':catColors[catIndex],opacity:'0.6' }}
        elevation={$hover ? 'large' : 'medium'}
      >
        <Stack>
          <Box fill>
            <Box
              round='medium'
              border={{
                size: $hover ? 'medium' : 'small',
                ...borderStyle
              }}
              height={$hover ? '50px' : '35px'}
              width={$hover ? '50px' : '35px'}
              background={{
                color: catColors[catIndex],
                // opacity: '0.8'
              }}
            />
          </Box>
          <Box fill align={'center'} justify={'center'}>
            <Icon width={'20px'} height={'20px'}
              size={$hover ? '20px' : '15px'} color={'white'} />
          </Box>
        </Stack>
      </Box>
    </div>)
}

export const AccountPin = ({ color, account = {}, show = false, text, $hover }) => {
  return (
    <div style={markerStyle}>
      <Box
        round
        background={color}
        elevation={show ? 'large' : 'none'}
      >
        <Stack>
          <Box fill>
            {/* <Box
              round
              // border={$hover || (show && { color: colorByType[data.record_type], size: 'small' })}
              height={'48px'}
              width={'48px'}
              background={{
                color: $hover || show ? 'mesh-accent-red' : color,
                opacity: $hover || show ? 'strong' : 'weak'
              }}
            /> */}
          </Box>
          <Box fill align={'center'} justify={'center'}>
            <MeshPin color={'white'} />
          </Box>
        </Stack>
      </Box>
    </div>
  )
}
const Sidebar = ({ iconButtons, show, children, width, region, short }) => {
  return (<AnimatePresence inital={true}>
    {show && (
      <MotionBox
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ type: 'spring', duration: 0.7 }}
        fill
        background='#FFF'
        width={width}
      >
        <CardHeader
          pad={{ left: 'medium', right: 'xxsmall', vertical: 'xxsmall' }}
          border={{ side: 'bottom', color: '#EFEFEF' }} direction='row'
          background={'#484487'} elevation='large'
        >
          {/*  */}
          <Box pad={'xsmall'} gap='xsmall'>
            <Heading margin={'xsmall'}>{region} {short !== 'COV' && 'Regional District'}</Heading>
            {/* <Heading margin={'xsmall'} level={2}>Food Recovery Network</Heading> */}
          </Box>
        </CardHeader>
        <CardBody>{children}</CardBody>
        <CardFooter justify='center'>
          <Box justify='center' align='center' margin={{ top: '20px' }}>
            <Text size='xsmall'>Powered by</Text>
            <LogoWithNoTagLine width={'100px'} />
            <Text textAlign="center" color={'dark-6'} size="xsmall">
              © Copyright Mesh Exchange Inc.
            </Text>
          </Box>

        </CardFooter>
      </MotionBox>
    )}
  </AnimatePresence>)
}

const _Map = ({ fromApi, apiActions, zoom, helpText, centerOfMap, pageTitle, region, short, apiArea }) => {
  const [impactMetrics, setImpactMetrics] = useState([]);
  const [metricsLoading, setMetricsLoading] = useState(false);
  const appContext = useContext(AppContext);
  const [mapDataFormed, setMapDataFormed] = useState(false);
  const [mapData, setMapData] = useState(defaultMapData1);
  const [activePanel, setActivePanel] = useState(0);
  const [totalPins, setTotalPins] = useState(0);
  const [allPins, setAllPins] = useState(null);
  const [totalVisiblePins, setTotalVisiblePins] = useState(0);
  const [clickedPin, setClickedPin] = useState(null);
  const [showVerified, setShowVerified] = useState(false);
  const [searchedList, setSearchedList] = useState([]);
  const [allOrgs, setAllOrgs] = useState([]);
  const [searchTxt, setSearchTxt] = useState('');
  useEffect(() => {
    firebase.analytics().logEvent('page_view', {
      page_title: pageTitle
    });
    setAttributes({ value: '' });
    getMetrics();
  }, []);
  useEffect(() => {
    setAttributes({ value: '' });
    getMetrics();
  }, [fromApi.results]);
  const onChildClick = (key, childProps) => {
    setClickedPin({ ...childProps.record, catIndex: childProps.catIndex });
  }
  const getMetrics = () => {
    setMetricsLoading(true);
    const common = {
      in_area: apiArea,
      page_size: 9999,
      annotate_metrics: true
    }
    const mkt = opsAPI.getFromMarketplace('network/impact', common)
    const retail = opsAPI.getFromRetail('network/donation_totals', common)
    const responses = Promise.all([mkt, retail])
    responses.then((result) => {
      const mktApiValues = getTotalByKeyFromResults(result[0].data.results, [
        'meals_provided__sum',
        'money_saved__sum',
        'food_rescued_kg__sum',
        'co2_emissions_kg__sum'
      ])
      const retailApiValues = getTotalByKeyFromResults(result[1].data.results, [
        'meals_provided__sum',
        'money_saved__sum',
        'food_rescued_kg__sum',
        'co2_emissions_kg__sum'
      ])
      const combinedValues = {
        meals_provided__sum:
          mktApiValues.meals_provided__sum + retailApiValues.meals_provided__sum,
        money_saved__sum: mktApiValues.money_saved__sum + retailApiValues.money_saved__sum,
        food_rescued_kg__sum:
          mktApiValues.food_rescued_kg__sum + retailApiValues.food_rescued_kg__sum,
        co2_emissions_kg__sum:
          mktApiValues.co2_emissions_kg__sum + retailApiValues.co2_emissions_kg__sum
      }
      const metricsObj = calculateImpactMetrics(
        0, 0, { showMoneySaved: true },
        combinedValues
      )
      setImpactMetrics(metricsObj);
      setMetricsLoading(false);
    })
      .catch((err) => {
        setMetricsLoading(false);
        appContext.actions.showResponseAsError(err)
      })
  }

  const setAttributes = ({ verified = null }) => {
    let data = fromApi.results;
    let allOrgs = [];
    const configWithResults = mapData.map(configItem => {
      const categoriesWithResults = configItem.categories.map(category => {
        let matchingResults = data.filter((result) => {
          return category.sf_attributes.some(attribute =>
            result.sf_attributes[attribute]
          )
        });
        matchingResults = matchingResults.map((matched) => {
          let verified = 0;
          if (regionsCities[short].includes(matched.city)) {
            if (['Active', 'Back-up'].includes(matched.sf_account_stage) &&
              Object.keys(matched.sf_attributes).some(att => ['Marketplace', 'Retail Program'].includes(att)))
              verified = 1;
            if (Object.keys(matched.sf_attributes).some(att => ['Non FoodMesh Network'].includes(att)))
              verified = 2;
          }
          matched['verified'] = verified;
          matched['show'] = 1;
          allOrgs.push(matched.name);
          return matched;
        });
        if (verified == 1) {
          matchingResults = matchingResults.filter(r => r.verified == 1);
        } else {
          matchingResults = matchingResults.filter(r => r.verified != 0);
        }
        return {
          ...category,
          results: matchingResults
        }
      })
      return {
        ...configItem,
        categories: categoriesWithResults
      }
    })
    let total = 0;
    configWithResults.map((cat) => {
      total = cat.categories.reduce((acc, obj) => acc + obj.results.length, total);
    });
    setTotalPins(total);
    if (!allPins)
      setAllPins(total)
    setTotalVisiblePins(total);
    setMapData(configWithResults);
    setMapDataFormed(true);
    // setSearchedList(allOrgs);
    setAllOrgs(allOrgs);
  }
  const sideDockWidth = '360px'
  const showHideCategory = (parent, child) => {
    let mapCategoriesData = mapData.map(m => ({ ...m }));
    const parentIndex = mapCategoriesData.findIndex(cat => cat.name === parent);
    if (parentIndex > -1) {
      let subCategories = mapCategoriesData[parentIndex].categories;
      if (!child) {
        let val = mapCategoriesData[parentIndex].show;
        mapCategoriesData[parentIndex].show = val == 1 ? 0 : 1;
        subCategories = mapCategoriesData[parentIndex].categories.map(s =>
          s.show = val == 1 ? { ...s, show: 0 } : { ...s, show: 1 });
        mapCategoriesData[parentIndex].categories = subCategories;
      } else {
        const childIndex = subCategories.findIndex(cat => cat.name === child);
        let val = subCategories[childIndex].show;
        mapCategoriesData[parentIndex].categories[childIndex].show = val == 1 ? 0 : 1;
        if (mapCategoriesData[parentIndex].categories.filter(c => c.show == 0).length > 0) {
          mapCategoriesData[parentIndex].show = 0;
        } else {
          mapCategoriesData[parentIndex].show = 1;
        }
      }
    }
    let totalVisible = 0;
    mapCategoriesData.map((cat) => {
      const t = cat.categories.reduce((acc, obj) => obj.show == 1 ?
        acc + obj.results.length : acc, 0);
      totalVisible += t ? t : 0;
    });
    setTotalVisiblePins(totalVisible);
    setMapData(mapCategoriesData);
  }
  const onSearch = (evt) => {
    const searchTxt = evt.target.value;
    let s = [];
    if (searchTxt.length > 2) {
      for (let category of mapData) {
        for (let cat of category.categories) {
          for (let result of cat.results) {
            if (result.name.toLowerCase().includes(searchTxt.toLowerCase())) {
              result.show = 1;
              s.push(result.name);
            } else {
              result.show = 0;
            }
          }
        }
      }
      setMapData(mapData);
      setSearchedList(Array.from(new Set(s)));
    } else {
      setSearchedList([]);
    }
    setSearchTxt(searchTxt);
  }
  return (
    <Box fill direction={'row'}>
      {<Sidebar
        region={region}
        short={short}
        show={true}
        width={{ min: sideDockWidth, max: sideDockWidth }}
        fill={false}
        flex={false}
      >
        <Main gap={'small'} pad={{ left: 'medium', top: 'medium', horizontal: 'small' }}>
          <TextInput value={searchTxt} suggestions={searchedList} onSuggestionSelect={() => { }}
            placeholder='Search...' onChange={onSearch} />
          <Accordion onActive={(newActiveIndex) => setActivePanel(newActiveIndex)}>
            {/* <AccordionPanel
              label={<><Heading level={3}>Organizations Search</Heading></>}>
              <TextInput value={searchTxt} placeholder='Search...' onChange={onSearch} />
              <Box pad={'small'}>
                {
                  searchedList.length > 0 && mapDataFormed && mapData.map((categoryData, k) => {
                    return categoryData.categories.map((subcategory, j) => {
                      let a = subcategory.results.reduce((acc, r) => {
                        if (searchedList.length > 0 && searchedList.includes(r.name)) acc.push(r.name);
                        else acc.push(r.name)
                        return acc;
                      }, []);
                      if (a.length > 0) {
                        return (
                          // <Box key={Math.random()} pad={'xsmall'} margin={{ bottom: 'xsmall' }}
                          //   border={{ side: 'left', color: catColors[k], size: 'small' }} >
                          <>
                            {/* <Box key={Math.random()} pad={'xsmall'} margin={{ bottom: 'xsmall' }}
                          background={catColors[k]} >
                          <Text style={{
                            fontSize: 'medium', color: 'white'
                          }}
                          >{subcategory.name}</Text>
                        </Box> 
                            {
                              subcategory.results.map((org, l) => {
                                {
                                  if (searchedList.length > 0) {
                                    return searchedList.includes(org.name) &&
                                      <Text style={{ fontSize: 'small' }} key={Math.random()}>{org.name}</Text>
                                  } else {
                                    return <Text style={{ fontSize: 'small' }} key={Math.random()}>{org.name}</Text>
                                  }
                                }
                              })
                            }</>)
                      }
                    })
                  })}</Box>

            </AccordionPanel> */}
            <AccordionPanel label={<><Heading level={3}>Organization Type</Heading>
              <Text weight={'bold'}>{totalVisiblePins}/{totalPins}</Text></>}>
              <>
                <Box margin={{ left: 'xsmall' }} flex={false}>
                  <Box border={{ side: 'bottom' }} fill='horizontal'
                    key={'verifiedcheck'} direction='row' align='center'>
                    <Box direction='row' pad={'xxsmall'} margin={'xxsmall'}>
                      <PearGreenGradLogo width={'24px'} size='medium' />&nbsp;
                      <Heading level={6} margin={'xsmall'} color={'dark-6'}>Show FoodMesh Verified</Heading>
                    </Box>
                    <Tip plain={true} content={<Box background={'light-3'} pad={'xsmall'} width={{ max: 'small' }} >
                      <Text size='small' color={'FFF'}>Any organization or business directly
                        engaged in a FoodMesh program.</Text></Box>}>
                      <Button icon={<CircleInformation size={'small'} />} />
                    </Tip>
                    <CheckBox size={'xsmall'} pad={{ left: 'small' }}
                      onChange={(event) => {
                        setShowVerified(!showVerified);
                        setAttributes({ verified: event.target.checked ? 1 : 2 })
                      }}
                      checked={showVerified}
                      label={''} />
                  </Box>
                  {
                    mapDataFormed && mapData.map((categoryData, k) => {
                      const total = categoryData.categories.reduce((acc, obj) => {
                        const t = obj.show == 1 ? acc + obj.results.length : acc;
                        return t;
                      }, 0)
                      const Icon = icons[k];
                      const ToggleIcon = categoryData.show == 0 ? Hide : FormView;
                      const tip = categoryData.show == 0 ? 'Show' : 'Hide';
                      return (
                        <Box margin='xsmall' border={{ side: 'all', color: catColors[k], size: 'small' }}
                          round='xsmall' key={categoryData.name}
                          direction='row' align='center'>
                          <Box fill='vertical'
                            pad={'xsmall'}
                            alignContent='center'
                            width={{ min: '50px' }}
                            background={catColors[k]} justify='center' align='center'>
                            <Heading margin={'xsmall'} color={'white'} level={2}>{total}</Heading>
                            <Icon color='white' width={'30px'} height={'30px'} />
                          </Box>
                          <Box fill='horizontal' pad={{ top: 0 }} margin={{ top: 0 }} >
                            <Box border={{ side: 'bottom' }} fill='horizontal'
                              key={categoryData.name} direction='row' align='center'>
                              <ToggleIcon text={tip} cursor={'pointer'} onClick={
                                () => showHideCategory(categoryData.name)} />
                              <Heading margin={'xsmall'} level={6}>{categoryData.name}</Heading>
                            </Box>
                            {categoryData.categories.map((category, i) => {
                              const SubIcon = category.show == 0 ? Hide : FormView;
                              return (
                                <Box fill='vertical'
                                  key={category.name} direction='row'>
                                  <SubIcon cursor={'pointer'} onClick={
                                    () =>
                                      showHideCategory(categoryData.name,
                                        category.name)} />
                                  <Tip plain content={<Box background={'light-3'} pad={'xsmall'}
                                    gap="small" width={{ max: 'small' }}>
                                    <Text size="small">
                                      {category.description}
                                    </Text>
                                  </Box>}>
                                    <Box direction='row' justify='between' fill='horizontal'
                                      align='center' margin={{ right: '10px' }}>
                                      <Text weight={'bold'}
                                        size='small' key={i}>{category.name}&nbsp;
                                        ({category.results.length})</Text>
                                      <CircleInformation size='small' />
                                    </Box>
                                  </Tip>
                                  {/* <Tip content={category.description}>
                                    <Button fill={false} size='small' icon={<Info size='small' />} />
                                  </Tip> */}

                                </Box>)
                            })}
                          </Box>
                        </Box>)
                    })
                  }
                </Box>
              </>
            </AccordionPanel>
            <AccordionPanel label={<Heading level={3}>Impact Metrics</Heading>}>
              <Text size="small" color="dark-6" margin={{ bottom: 'small', top: 'none' }}>
                {helpText}
              </Text>
              <DonationMetricsSmall
                rows={'auto'}
                columns={{
                  count: 'fill',
                  size: '40%'
                }}
                loading={metricsLoading}
                flex={false}
                height={{ min: '254px' }}
                metrics={impactMetrics}
              /><br />
              <MetricsBox
                width={'100%'}
                item={{
                  Icon: Group,
                  id: 'network',
                  value: allPins,
                  name: 'Total network participants'
                }}
                loading={metricsLoading}
              />
              <Box fill={'horizontal'} pad="xsmall" flex={false}>
                <Anchor
                  size={'small'}
                  label={'Our stats explained'}
                  reverse
                  weight={'normal'}
                  color={'dark-6'}
                  icon={<CircleInformation size={'small'} />}
                  href={'https://foodmesh.ca/our-stats-explained/'}
                  target={'_blank'}
                />
              </Box>
              <Box />
            </AccordionPanel>
            <AccordionPanel label={<Heading level={3}>Surplus Marketplaces</Heading>}>
              {
                // Object.keys(surplusMarketplaces).map((region) => (
                <SurplusMarketplaceComponent key={short} region={short} />
                // ))
              }
            </AccordionPanel>
            <Box />{' '}

            <Box pad={'medium'} />
          </Accordion>
        </Main>
      </Sidebar>}
      <Box height={'100%'} width={'100%'}>
        <GoogleMap
          bootstrapURLKeys={{ key: process.env.REACT_APP_GCP_API_KEY }}
          defaultCenter={centerOfMap}
          defaultZoom={zoom}
          onChildClick={onChildClick}
          options={{ fullscreenControl: false }}
        >{mapDataFormed &&
          mapData.map((cat, k) => {
            return cat.categories.map((subcat, i) => {
              return subcat.show == 1 &&
                subcat.results.map((r) => {
                  if (searchedList.length > 0) {
                    return r.location && searchedList.includes(r.name) && (<MapPin
                      lat={r.location.coordinates[1]}
                      lng={r.location.coordinates[0]}
                      catIndex={k} subCatIndex={i} record={r} key={`${k}-${i}-${r.name}_${Math.random(1, 10)}`} />)
                  } else {
                    return r.location && (<MapPin
                      lat={r.location.coordinates[1]}
                      lng={r.location.coordinates[0]}
                      catIndex={k} subCatIndex={i} record={r} key={`${k}-${i}-${r.name}_${Math.random(1, 10)}`} />)
                  }
                })


            })
          })
          }
        </GoogleMap>
        <MotionLayer
          margin={{ right: '60px', bottom: '20px' }}
          modal={false}
          position={'bottom-right'}
          plain
        >
          <AnimatePresence>
            <Box gap={'small'} pad={'medium'}>
              <AccountCard
                initial={{ opacity: 1, y: 50, height: 0 }}
                animate={{ opacity: 1, y: 0, height: 300 }}
                exit={{ opacity: 0, y: 50, height: 0 }}
                overflow={'hidden'}
                key={'info'}
                flex={'grow'}
                width={'medium-small'}
                round={'small'}
                fill={false}
                closeAction={() => setClickedPin(null)}
                {...(clickedPin || {})}
                show={clickedPin}
              />
            </Box>
          </AnimatePresence>
        </MotionLayer>
      </Box>
    </Box>
  )
}
_Map.defaultProps = {
  fromApi: { results: [], apiParams: { with_attributes: [] } },
  apiActions: {},
  // centerOfMap: { lat: 50.404243, lng: -118.694654 },
  zoom: 10
}


export const ApiMap = withOpsApi(_Map, { color: '#7a9bb7' })
export const NetworkMap = ({ values }) => {
  return (
    <ApiMap
      zoom={values.zoom}
      apiArea={values.apiArea}
      region={values.region}
      short={values.short}
      centerOfMap={values.centerOfMap}
      pageTitle={values.pageTitle}
      helpText={values.helpText}
      apiParams={{ in_area: [values.apiArea], limit: 999 }}
      apiPath={'retail/network/'}
    />
  )
}
const SurplusMarketplaceComponent = ({ region }) => {
  const { Sell, Donate, link } = surplusMarketplaces[region];

  return (
    <>
      {Sell && Sell.length > 0 && (
        <>
          <Heading level={4}>
            Sell
          </Heading>
          {Sell.map((sell, index) => (
            <>
              <Anchor size='large' href={sell.link}
                target='_blank'
                color={'dark-6'} label={sell.label}
              >
              </Anchor>
              <Text><i>{sell.description}</i></Text>
              <br />
            </>
          ))}
        </>
      )}
      {Donate && Donate.length > 0 && (
        <>
          <Heading level={4}>
            Donate
          </Heading>
          {Donate.map((donate, index) => (
            <>
              <Anchor size='large' href={donate.link}
                target='_blank'
                color={'dark-6'} label={donate.label}
              >
              </Anchor>
              <Text><i>{donate.description}</i></Text>
              <br />
            </>
          ))}
        </>
      )}

      {link && (
        <>
          <Anchor size='large' href='https://foodmesh.ca/our-services/marketplace/'>
            <Box pad={{ bottom: 'large' }} direction='row' align='center'>
              <Text size='xlarge'>Buy, sell and donate surplus food</Text>
              <FormNextLink />
            </Box>
          </Anchor>
        </>
      )}
    </>
  );
};